var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.62826e-08 23.1178C-2.07214e-08 22.8254 0.237026 22.5884 0.529412 22.5884L23.1176 22.5884C23.41 22.5884 23.6471 22.8254 23.6471 23.1178C23.6471 23.4102 23.41 23.6472 23.1176 23.6472L0.529412 23.6472C0.237026 23.6472 -7.18438e-08 23.4102 -4.62826e-08 23.1178Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.124 0.0934938C12.2674 0.192301 12.353 0.355291 12.353 0.529415V23.1177C12.353 23.41 12.116 23.6471 11.8236 23.6471H1.94128C1.64889 23.6471 1.41187 23.41 1.41187 23.1177V4.29412C1.41187 4.07445 1.54753 3.87759 1.75281 3.79939L11.6352 0.0346859C11.7979 -0.0273013 11.9807 -0.00531309 12.124 0.0934938ZM2.47069 4.65897V22.5882H11.2942V1.29762L2.47069 4.65897Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5232 0.0934938C11.6666 -0.00531309 11.8494 -0.0273013 12.0121 0.0346859L21.8944 3.79939C22.0997 3.87759 22.2354 4.07445 22.2354 4.29412V23.1177C22.2354 23.41 21.9983 23.6471 21.706 23.6471H11.8236C11.5312 23.6471 11.2942 23.41 11.2942 23.1177V0.529415C11.2942 0.355291 11.3798 0.192301 11.5232 0.0934938ZM12.353 1.29762V22.5882H21.1765V4.65897L12.353 1.29762Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.842 4.61213C13.9264 4.33218 14.2217 4.17364 14.5017 4.25801L19.0154 5.61844C19.2954 5.70281 19.4539 5.99816 19.3695 6.2781C19.2852 6.55805 18.9898 6.71659 18.7099 6.63222L14.1961 5.27179C13.9162 5.18742 13.7576 4.89208 13.842 4.61213Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8354 7.58319C13.9066 7.29961 14.1943 7.12747 14.4778 7.19869L18.9916 8.33238C19.2752 8.4036 19.4473 8.69123 19.3761 8.97481C19.3049 9.25838 19.0172 9.43053 18.7337 9.35931L14.2199 8.22562C13.9363 8.15439 13.7642 7.86677 13.8354 7.58319Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8298 10.5556C13.8874 10.2689 14.1665 10.0832 14.4531 10.1408L18.9669 11.0478C19.2536 11.1054 19.4392 11.3845 19.3816 11.6711C19.3241 11.9578 19.045 12.1435 18.7583 12.0859L14.2446 11.1789C13.9579 11.1213 13.7722 10.8423 13.8298 10.5556Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8253 13.5287C13.8689 13.2396 14.1386 13.0405 14.4277 13.0841L18.9415 13.7643C19.2306 13.8079 19.4297 14.0776 19.3861 14.3667C19.3425 14.6558 19.0728 14.8549 18.7837 14.8113L14.2699 14.1311C13.9808 14.0875 13.7817 13.8178 13.8253 13.5287Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.822 16.5019C13.8513 16.211 14.1108 15.9989 14.4017 16.0281L18.9155 16.4816C19.2064 16.5108 19.4185 16.7703 19.3893 17.0612C19.3601 17.3522 19.1005 17.5643 18.8096 17.5351L14.2959 17.0816C14.0049 17.0524 13.7928 16.7928 13.822 16.5019Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.82 19.476C13.8347 19.184 14.0833 18.9592 14.3753 18.9738L18.8891 19.2006C19.1811 19.2152 19.4059 19.4638 19.3913 19.7559C19.3766 20.0479 19.128 20.2727 18.836 20.2581L14.3222 20.0313C14.0302 20.0166 13.8053 19.768 13.82 19.476Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43912 4.61213C9.52349 4.89208 9.36495 5.18742 9.085 5.27179L4.57124 6.63222C4.29129 6.71659 3.99595 6.55805 3.91158 6.2781C3.8272 5.99816 3.98575 5.70281 4.26569 5.61844L8.77945 4.25801C9.0594 4.17364 9.35474 4.33218 9.43912 4.61213Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44568 7.58319C9.5169 7.86677 9.34475 8.15439 9.06118 8.22562L4.54742 9.35931C4.26384 9.43053 3.97621 9.25838 3.90499 8.97481C3.83377 8.69123 4.00591 8.4036 4.28949 8.33238L8.80325 7.19869C9.08683 7.12747 9.37445 7.29961 9.44568 7.58319Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45123 10.5556C9.50883 10.8423 9.32314 11.1213 9.03648 11.1789L4.52272 12.0859C4.23606 12.1435 3.95699 11.9578 3.89939 11.6711C3.84179 11.3845 4.02748 11.1054 4.31414 11.0478L8.8279 10.1408C9.11456 10.0832 9.39363 10.2689 9.45123 10.5556Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45566 13.5287C9.49923 13.8178 9.30017 14.0875 9.01105 14.1311L4.49729 14.8113C4.20817 14.8549 3.93847 14.6558 3.8949 14.3667C3.85133 14.0776 4.05039 13.8079 4.33951 13.7643L8.85327 13.0841C9.14239 13.0405 9.41209 13.2396 9.45566 13.5287Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45913 16.5019C9.48836 16.7928 9.27621 17.0524 8.98529 17.0816L4.47153 17.5351C4.18061 17.5643 3.92108 17.3522 3.89185 17.0612C3.86262 16.7703 4.07477 16.5108 4.36569 16.4816L8.87945 16.0281C9.17037 15.9989 9.4299 16.211 9.45913 16.5019Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46109 19.476C9.47576 19.768 9.25092 20.0166 8.9589 20.0313L4.44514 20.2581C4.15313 20.2727 3.90451 20.0479 3.88984 19.7559C3.87517 19.4638 4.10001 19.2152 4.39202 19.2006L8.90578 18.9738C9.1978 18.9592 9.44642 19.184 9.46109 19.476Z",
    fill: "inherit"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.1ea93ddb1624541d06ee12c1087f219c.svg";
export { ForwardRef as ReactComponent };